export default __webpack_public_path__ + "static/media/slide-item2.223442f5.svg";